<template>
  <div>
    <v-container fluid>
      <v-card v-show="!loading" class="mb-3">
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>{{ titulo }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            class="mr-2"
            color="primary lighten-3"
            @click="$router.go(-1)"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="primary lighten-4"
            @click="salvar"
            :loading="loadingSalvar"
            :disabled="!form_valid"
            >Salvar</v-btn
          >
        </v-app-bar>

        <v-form ref="form" lazy-validation v-model="form_valid">
          <v-container fluid class="pa-2">
            <v-row dense v-show="!loading">
              <v-col cols="12" sm="7" class="pa-3">
                <v-text-field
                  ref="nome"
                  autocomplete="off"
                  role="presentation"
                  label="Nome"
                  :rules="rulesForm.nome"
                  v-model="administrador.nome"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="5" class="pa-3">
                <v-text-field
                  autocomplete="off"
                  role="presentation"
                  ref="cnpj"
                  label="CNPJ"
                  v-mask="'##.###.###/####-##'"
                  :return-masked-value="true"
                  :rules="rulesForm.cnpj"
                  v-model="administrador.cnpj"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row dense v-show="!loading">
              <v-col cols="12" sm="4" class="pa-3">
                <v-text-field
                  autocomplete="off"
                  role="presentation"
                  ref="logradouro"
                  label="Logradouro"
                  :rules="rulesForm.logradouro"
                  v-model="administrador.endereco.rua"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" class="pa-3">
                <v-text-field
                  autocomplete="off"
                  role="presentation"
                  ref="complemento"
                  label="Complemento"
                  :rules="rulesForm.complemento"
                  v-model="administrador.endereco.complemento"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" class="pa-3">
                <v-text-field
                  autocomplete="off"
                  role="presentation"
                  ref="numero"
                  label="Número"
                  :rules="rulesForm.numero"
                  v-model="administrador.endereco.numero"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" class="pa-3">
                <v-text-field
                  autocomplete="off"
                  role="presentation"
                  ref="bairro"
                  label="Bairro"
                  :rules="rulesForm.bairro"
                  v-model="administrador.endereco.bairro"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row dense v-show="!loading">
              <v-col cols="12" sm="4" class="pa-3">
                <v-select
                  autocomplete="off"
                  role="presentation"
                  :items="estados"
                  ref="estado"
                  label="Estado"
                  :rules="rulesForm.estado"
                  v-model="administrador.endereco.estado_id"
                  @change="onSelectEstado"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="5" class="pa-3">
                <v-autocomplete
                  autocomplete="off"
                  role="presentation"
                  :items="cidades"
                  ref="cidade"
                  label="Cidade"
                  :rules="rulesForm.cidade"
                  v-model="administrador.endereco.cidade_id"
                  :loading="loadingCidades"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" class="pa-3">
                <v-text-field
                  autocomplete="off"
                  role="presentation"
                  ref="cep"
                  label="CEP"
                  :rules="rulesForm.cep"
                  v-model="administrador.endereco.cep"
                  v-mask="'#####-###'"
                  :return-masked-value="true"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row dense v-show="!loading">
              <v-col cols="12" sm="4" class="pa-3">
                <v-text-field
                  autocomplete="off"
                  role="presentation"
                  ref="telefone"
                  label="Telefone"
                  :rules="rulesForm.telefone"
                  v-model="administrador.endereco.telefone"
                  v-mask="'(##) ####-####'"
                  :return-masked-value="true"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" class="pa-3">
                <v-text-field
                  autocomplete="off"
                  role="presentation"
                  ref="celular"
                  label="Celular"
                  :rules="rulesForm.celular"
                  v-model="administrador.endereco.celular"
                  v-mask="'(##) #####-####'"
                  :return-masked-value="true"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" class="pa-3">
                <v-text-field
                  autocomplete="off"
                  role="presentation"
                  ref="email"
                  label="E-mail"
                  :rules="rulesForm.email"
                  v-model="administrador.endereco.email"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card>
    </v-container>
    <v-layout v-show="loading" justify-center align-center mt-5>
      <v-progress-circular
        indeterminate
        size="50"
        width="3"
        color="primary"
      ></v-progress-circular>
    </v-layout>
  </div>
</template>

<script>
import Services from "@/services/services.js";
import ServiceAdministradores from "@/services/administradores.js";
import validadores from "@/mixins/validadores-mixin";

export default {
  name: "MinhaContaAdministrador",
  mixins: [validadores],
  data() {
    return {
      loading: false,
      loadingSalvar: false,
      loadingCidades: false,
      titulo: "Minha Conta",
      exibirPesquisa: false,
      pesquisa: "",
      form_valid: true,
      administrador: {
        nome: "",
        cnpj: "",
        endereco: {
          rua: "",
          numero: "",
          complemento: "",
          bairro: "",
          cidade: "",
          cidade_id: "",
          estado: "",
          estado_id: "",
          cep: "",
          telefone: "",
          celular: "",
          email: "",
        },
      },
      rulesForm: {
        nome: [(value) => !!value || "Obrigatório"],
        cnpj: [
          (value) => !!value || "Obrigatório",
          (value) => this.validarCNPJ(value) || "CNPJ Inválido",
        ],
        logradouro: [(value) => !!value || "Obrigatório"],
        numero: [(value) => !!value || "Obrigatório"],
        complemento: [(value) => true],
        bairro: [(value) => !!value || "Obrigatório"],
        estado: [(value) => !!value || "Obrigatório"],
        cidade: [(value) => !!value || "Obrigatório"],
        cep: [(value) => !!value || "Obrigatório"],
        telefone: [(value) => !!value || "Obrigatório"],
        celular: [(value) => !!value || "Obrigatório"],
        email: [
          (value) => !!value || "Obrigatório",
          (value) => this.validarEmail(value) || "E-mail inválido",
        ],
      },
      cidades: [],
      estados: [],
    };
  },
  mounted() {
    this.carregarEstados();
    this.abrir(this.$auth.user.administrador_id);
  },
  methods: {
    async carregarEstados() {
      this.estados = Services.estados();
    },
    async abrir(administrador) {
      try {
        this.loading = true;
        let response = await ServiceAdministradores.index(administrador);
        this.administrador = response.data.administrador;
        let cidades = await Services.cidades(
          this.administrador.endereco.estado
        );
        this.cidades = cidades.data.cidades;
        this.onSelectEstado();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async onSelectEstado() {
      try {
        this.loadingCidades = true;
        let response = await Services.cidades(
          this.administrador.endereco.estado_id
        );
        this.cidades = response.data.cidades;
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingCidades = false;
      }
    },
    async salvar() {
      if (this.$refs.form.validate()) {
        try {
          this.loadingSalvar = true;
          await ServiceAdministradores.salvarConfig({
            administrador: this.administrador,
          });
          this.$eventbus.notificar("Dados da conta salvos com sucesso");
        } catch (error) {
          this.$eventbus.erro(
            error.response?.data?.message ||
              error.response?.data?.msg ||
              "Erro ao salvar os dados",
            error
          );
        } finally {
          this.loadingSalvar = false;
        }
      }
    },
  },
};
</script>
